/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getClinicalDictionaryTypes } from 'app/entities/clinical-dictionary-type/clinical-dictionary-type.reducer';
import { createEntity, getEntity, reset, updateEntity } from './rx-calculator-formula.reducer';

export const RxCalculatorFormulaUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const clinicalDictionaryTypes = useAppSelector(state => state.clinicalDictionaryType.entities);
  const rxCalculatorFormulaEntity = useAppSelector(state => state.rxCalculatorFormula.entity);
  const loading = useAppSelector(state => state.rxCalculatorFormula.loading);
  const updating = useAppSelector(state => state.rxCalculatorFormula.updating);
  const updateSuccess = useAppSelector(state => state.rxCalculatorFormula.updateSuccess);

  const handleClose = () => {
    navigate(`/rx-calculator-formula${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getClinicalDictionaryTypes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...rxCalculatorFormulaEntity,
      ...values,
      category: clinicalDictionaries.find(it => it.id.toString() === values.category?.toString()),
      categoryType: clinicalDictionaryTypes.find(it => it.id.toString() === values.categoryType?.toString()),
      entityType: clinicalDictionaries.find(it => it.id.toString() === values.entityType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...rxCalculatorFormulaEntity,
          category: rxCalculatorFormulaEntity?.category?.id,
          categoryType: rxCalculatorFormulaEntity?.categoryType?.id,
          entityType: rxCalculatorFormulaEntity?.entityType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.rxCalculatorFormula.home.createOrEditLabel" data-cy="RxCalculatorFormulaCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.home.createOrEditLabel">
              Create or edit a RxCalculatorFormula
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="rx-calculator-formula-id"
                  label={translate('tinyMedicRestApp.rxCalculatorFormula.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.name')}
                id="rx-calculator-formula-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.description')}
                id="rx-calculator-formula-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.formulaString')}
                id="rx-calculator-formula-formulaString"
                name="formulaString"
                data-cy="formulaString"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.entityId')}
                id="rx-calculator-formula-entityId"
                name="entityId"
                data-cy="entityId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.active')}
                id="rx-calculator-formula-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.cursor')}
                id="rx-calculator-formula-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.lastUpdated')}
                id="rx-calculator-formula-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.microSec')}
                id="rx-calculator-formula-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.timestampEntry')}
                id="rx-calculator-formula-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.rxCalculatorFormula.conceptId')}
                id="rx-calculator-formula-conceptId"
                name="conceptId"
                data-cy="conceptId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="rx-calculator-formula-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.rxCalculatorFormula.category')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="rx-calculator-formula-categoryType"
                name="categoryType"
                data-cy="categoryType"
                label={translate('tinyMedicRestApp.rxCalculatorFormula.categoryType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaryTypes
                  ? clinicalDictionaryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="rx-calculator-formula-entityType"
                name="entityType"
                data-cy="entityType"
                label={translate('tinyMedicRestApp.rxCalculatorFormula.entityType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/rx-calculator-formula" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RxCalculatorFormulaUpdate;
